// extracted by mini-css-extract-plugin
export default {"brand-area":"jBK7djgnoM08ctHjg0hA","brand-row":"_Uh8vn8rJCAqeLFJNRUc","inner-cell":"SYL4glKJtEuXp4qGxuIg","left-border":"nESQK7SEtTMkrG7x7nb3","brand-item":"_MdWxVY0X3NFqfj7AFZw"};